// Reads data-customer-has-free-swatch off <cart-content> (same tag check as Liquid, not raw
// cart JSON); it's already morphed by the time "cart:updated" fires.

// Exposed for product-grouping.js, whose captured price-snippet markup can be stale vs the cart.
function syncSwatchPriceSnippet(priceSnippet) {
  if (!priceSnippet || priceSnippet.dataset.swatchProduct !== "true") return;

  const rawPrice = parseFloat(priceSnippet.dataset.rawPrice);

  if (Number.isNaN(rawPrice)) return;

  const price = window.customerHasFreeSwatch ? rawPrice : 0;
  const compareAtPrice = window.customerHasFreeSwatch ? 0 : rawPrice;

  priceSnippet.setAttribute("price", String(price));
  priceSnippet.setAttribute("compare-at-price", String(compareAtPrice));

  priceSnippet.dataset.basePrice = String(price);
  priceSnippet.dataset.baseCompareAtPrice = String(compareAtPrice);
  priceSnippet.dataset.freePrice = String(!window.customerHasFreeSwatch);
}

window.syncSwatchPriceSnippet = syncSwatchPriceSnippet;

function refreshPriceSnippets() {
  document.querySelectorAll('price-snippet[data-swatch-product="true"]').forEach(syncSwatchPriceSnippet);
}

function refreshAddToCartButtons() {
  document.querySelectorAll('[data-product-form-atc][data-swatch-product="true"]').forEach((button) => {
    const rawPrice = parseFloat(button.dataset.rawPrice);

    button.dataset.freePrice = String(!window.customerHasFreeSwatch);

    if (Number.isNaN(rawPrice) || button.disabled) return;

    const content = button.querySelector(".product-form__atc-content");

    if (!content) return;

    const currency = document.querySelector("[data-main-product-price]")?.getAttribute("currency") || "USD";
    const displayPrice = window.customerHasFreeSwatch ? rawPrice : 0;
    const formattedPrice = window.formatMoney(displayPrice / 100, true, currency);
    const addToCartLabel = button.closest("product-form")?.dataset.localeAdd || "Add to cart";

    content.textContent = `${addToCartLabel} - ${formattedPrice}`;
  });
}

document.addEventListener("cart:updated", () => {
  const cartContentEl = document.querySelector("cart-content[data-customer-has-free-swatch]");

  if (!cartContentEl) return;

  const hasFreeSwatch = cartContentEl.dataset.customerHasFreeSwatch === "true";

  if (hasFreeSwatch === window.customerHasFreeSwatch) return;

  window.customerHasFreeSwatch = hasFreeSwatch;

  refreshPriceSnippets();
  refreshAddToCartButtons();
});
